import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import SimpleSlider from 'components/Slider';
import Loader from 'components/Loader'

import * as S from './styled';

const WeatherInfo = ({ date, wether, geoData: { location }, isCelsius, tLocation }) => {
  const { t } = useTranslation();
 
  if (wether.todayWeather && date) {
    const { todayWeather, fifteenWeather } = wether;
    const { appTemp, temp, rh, code, icon, windSpd } = todayWeather;

    const currentTemp = isCelsius ? temp : (temp * 9) / 5 + 35;
    const currentAppTemp = isCelsius ? appTemp : (appTemp * 9) / 5 + 35;
    const currentLocation = tLocation.length !== 0 ? tLocation : location;

    const {
      today: { day, numDay, month, year },
      time,
    } = date;
    return (
      <S.WeatherBox>
        <S.LocationName>{currentLocation}</S.LocationName>
        <S.Date>{`${t(`day.${day}`)} ${numDay} ${t(`month.${month}`)} ${year} ${time}`}</S.Date>
        <S.TodayContainer>
          <S.TodayTemperature src={`https://www.weatherbit.io/static/img/icons/${icon}.png`}>
            {`${Math.round(currentTemp)}°`}
          </S.TodayTemperature>
          <div>
            <S.WeatherImg src={`https://www.weatherbit.io/static/img/icons/${icon}.png`} />
            <S.WeatherBox>
              <S.TodayWeather>
                {`${t(`wether.${code}`)}`}
                <br />
                {`${t('feel')} ${Math.round(currentAppTemp)}°`}
                <br />
                {`${t('wind')} ${Math.round(windSpd)}`}
                <S.Span> m/s</S.Span>
                <br />
                {`${t('humidity')} ${rh}%`}
              </S.TodayWeather>
            </S.WeatherBox>
          </div>
        </S.TodayContainer>
        <SimpleSlider fifteenWeather={fifteenWeather} isCelsius={isCelsius} />
      </S.WeatherBox>
    );
  }
  return <S.WeatherBox><Loader /></S.WeatherBox>;
};

WeatherInfo.defaultProps = {
  date: null,
  geoData: null,
  wether: null,
  tLocation: '',
};

WeatherInfo.propTypes = {
  date: PropTypes.shape({
    today: PropTypes.shape({
      day: PropTypes.number,
      numDay: PropTypes.number,
      month: PropTypes.number,
      year: PropTypes.number,
    }),
    time: PropTypes.string,
  }),
  wether: PropTypes.shape({
    todayWeather: PropTypes.shape({
      appTemp: PropTypes.number,
      temp: PropTypes.number,
      rh: PropTypes.number,
      code: PropTypes.number,
      icon: PropTypes.string,
      windSpd: PropTypes.number,
    }),
    fifteenWeather: PropTypes.arrayOf(
      PropTypes.shape({
        temp: PropTypes.number,
        icon: PropTypes.string,
        date: PropTypes.string,
      })
    ),
  }),
  geoData: PropTypes.shape({
    lat: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    lng:  PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    DMS: PropTypes.shape({
      lat: PropTypes.string,
      lng: PropTypes.string,
    }),
    location: PropTypes.string,
    offsetSec: PropTypes.number,
  }),
  isCelsius: PropTypes.bool.isRequired,
  tLocation: PropTypes.string,
};

export default WeatherInfo;
